module.exports = __webpack_public_path__ + "static/img/icon_staut.ff47553.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/icon_staut.png
// module id = tDXW
// module chunks = 11